module.exports = __webpack_public_path__ + "img/orange_083.8587d09d.png";